import request from '@/utils/request'
const Api = {
    DownloadHeader: '/Frontend/Download/header',
    DownloadList: '/Frontend/Download/list'
}

/**
 * 封头配置
 * @returns 
 */
export function getDownloadHeader() {
    return request({
        url: Api.DownloadHeader,
        method: 'get',
    })
}
/**
 * 软件列表
 * @returns 
 */
 export function getDownloadList() {
    return request({
        url: Api.DownloadList,
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/download.js